"use client";

import { useEffect, useMemo, useState } from "react";
import { StatusPage } from "@/components/pages/StatusPage";
import styles from "@/components/pages/status-page.module.css";
import { notoSansArabic, sohne, sohneMono } from "./fonts";
import { getStatusCopy } from "@/lib/status-copy";
import type { SiteLocale } from "@/content/schema";

/**
 * Root layout / template failures — must define its own `<html>` + `<body>`.
 * Locale inferred from the URL path (`/ar…` → Arabic).
 */
export default function GlobalError({
  error,
  reset,
  retry,
}: {
  error: Error & { digest?: string };
  reset: () => void;
  retry?: () => void;
}) {
  const [locale, setLocale] = useState<SiteLocale>("en");
  const copy = useMemo(() => getStatusCopy(locale, "error"), [locale]);

  useEffect(() => {
    if (window.location.pathname.startsWith("/ar")) {
      setLocale("ar");
    }
  }, []);

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html
      lang={copy.locale === "ar" ? "ar" : "en"}
      dir={copy.dir}
      className={`${sohne.variable} ${sohneMono.variable} ${notoSansArabic.variable} subpage ${styles.document}`}
    >
      <body className={`subpage ${styles.documentBody}`}>
        <title>{copy.metaTitle}</title>
        <StatusPage copy={copy} onReset={retry ?? reset} />
      </body>
    </html>
  );
}
